var map = {
	"./HomeBackgroundImage.jpg": 7754,
	"./HomeBgImage.jpg": 4917,
	"./about-us.jpg": 7444,
	"./brand-logo.png": 7533,
	"./doctor-1.jpg": 2171,
	"./doctor-2.jpg": 7516,
	"./doctor-3.jpg": 4393,
	"./doctor-4.jpg": 7674,
	"./hero-banner.jpg": 1921,
	"./hero-banner.png": 2521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;